import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createOnlinePayment } from "../features/payment/paymentThunks";
import { loadRazorpay } from "../utils/loadRazorpay";

/**
 * Reusable Razorpay Online Payment Hook
 */
const useOnlinePayment = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.merchant);

  /**
   * Initiate Razorpay Payment
   */
  const startOnlinePayment = useCallback(
    async ({
      bookingId,
      amount,
      paymentFor,
      isPartialPayment = false,
      onSuccess,
      onFailure,
    }) => {
      try {
        // 1️⃣ Create order from backend
        const result = await dispatch(
          createOnlinePayment({
            bookingId,
            amount,
            currency: "INR",
            paymentFor,
            payment_method: "online",
            isPartialPayment,
          })
        );

      if (!createOnlinePayment.fulfilled.match(result)) {
  throw new Error("Failed to create online payment");
}

// ✅ CORRECT EXTRACTION
const razorpayOrderId = result.payload?.orderId; // Razorpay order id
const orderId = result.payload?._id;             // Internal DB id

// console.log("🟢 Razorpay Order ID:", razorpayOrderId);
// console.log("🟢 Internal Payment ID:", orderId);

// ✅ SAFETY CHECK
// if (!razorpayOrderId || !orderId) {
//   console.error("❌ Invalid payment response", result.payload);
//   throw new Error("Invalid payment order response");
// }
        // 2️⃣ Load Razorpay SDK

        // 3️⃣ Open Razorpay
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID, // move to ENV in prod
          amount: amount * 100,
          currency: "INR",
          name: "MSZILA",
          description: "Online Payment",
          order_id: razorpayOrderId,

          prefill: {
            name: user?.fullName || "",
            email: user?.email || "",
            contact: user?.mobileNumber || "",
          },

          handler: function (response) {
            onSuccess?.({
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              ...response,
              orderId,
              bookingId,
            });
          },

          modal: {
            ondismiss: () => {
              onFailure?.("Payment popup closed");
            },
          },

          theme: {
            color: "#2563eb",
          },
        };
        
  const loaded = await loadRazorpay();

if (!loaded || !window.Razorpay) {
  throw new Error("Razorpay SDK failed to load");
}

// Open Razorpay
const rzp = new window.Razorpay(options);
rzp.open();
      } catch (err) {
        console.error("Online payment error:", err);
        onFailure?.(err.message || "Payment failed");
      }
    },
    [dispatch, user]
  );

  return {
    startOnlinePayment,
  };
};

export default useOnlinePayment;
